<section
  class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-5"
  aria-label="Verkaufstatistiken">
  <app-kpi-card
    accent="default"
    label="Verkaufte Gutscheine"
    [value]="(statistics?.total_vouchers_sold || 0).toString()"
    [subtext]="internalCountNote">
    <ng-template #icon><ng-icon name="lucideTicket" /></ng-template>
  </app-kpi-card>

  <app-kpi-card
    accent="default"
    label="Eingelöste Gutscheine"
    [value]="(statistics?.total_vouchers_redeemed || 0).toString()"
    [subtext]="internalRedeemedNote">
    <ng-template #icon><ng-icon name="lucideTicketCheck" /></ng-template>
  </app-kpi-card>

  <app-kpi-card
    accent="default"
    label="Erstattete Gutscheine"
    [value]="(statistics?.total_vouchers_refunded || 0).toString()">
    <ng-template #icon><ng-icon name="lucideRotateCcw" /></ng-template>
  </app-kpi-card>

  <app-kpi-card
    accent="default"
    label="Ausgegebener Gutscheinwert"
    [value]="money(statistics?.total_turnover)"
    [subtext]="internalValueNote">
    <ng-template #icon><ng-icon name="lucideBanknote" /></ng-template>
  </app-kpi-card>

  <app-kpi-card
    accent="default"
    label="Ungenutzter Gutscheinwert"
    [value]="money(statistics?.current_unused_value)"
    [subtext]="internalUnusedValueNote">
    <ng-template #icon><ng-icon name="lucidePiggyBank" /></ng-template>
  </app-kpi-card>
</section>
